export default {
  ru: {
    broadcast: 'Прямой эфир'
  },

  en: {
    broadcast: 'Broadcasting now'
  }
}
